module.exports = __webpack_public_path__ + "media/images/icon-cancel-outline-1cbaae4427aa96ad94186a219498bb1a.svg";